import { render } from "./Feed.vue.js?vue&type=template&id=66e810ba&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Feed.vue?vue&type=template&id=66e810ba&scoped=true"
import script from "./Feed.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Feed.vue?vue&type=script&lang=js"
export * from "./Feed.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Feed.vue?vue&type=script&lang=js"

import "./Feed.vue.scss?vue&type=style&index=0&id=66e810ba&lang=scss&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Feed.vue?vue&type=style&index=0&id=66e810ba&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e810ba"],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/Feed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66e810ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66e810ba', __exports__)) {
    api.reload('66e810ba', __exports__)
  }
  
  module.hot.accept("./Feed.vue.js?vue&type=template&id=66e810ba&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Feed.vue?vue&type=template&id=66e810ba&scoped=true", () => {
    api.rerender('66e810ba', render)
  })

}


export default __exports__